import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { PrimaryCareProviderOptionCardComponent } from "../primary-care-provider-option-card/primary-care-provider-option-card.component";
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../../../../../environments/environment';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-primary-care-provider-mobile',
  imports: [CommonModule, TranslateModule, MatProgressSpinnerModule, MatCardModule, MatButtonModule, PrimaryCareProviderOptionCardComponent],
  templateUrl: './primary-care-provider.component.html',
  styleUrl: './../../../../../styles.css',
})
export class PrimaryCareProviderComponent {

  @Input() locale: string | null = null;
  @Input() isPlus: boolean | null = null;
  @Input() primaryCareProviderOptions: Array<any> = [];
  @Input() pcpId: string | null = null;
  @Input() isOpenScheduling: boolean | null = null;

  public title: string = 'TITLE';
  public description: string = 'DESCRIPTION';
  public showMoreText: string = 'SHOW_MORE';

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(this.locale || 'en-US'); // Default to 'en-US' if no locale is provided
  }
  ngOnInit(): void {
    this.translate.use(this.locale || 'en-US');  // ensure locale is set on init

    this.translate.get('PRIMARYCAREVISIT.TITLE').subscribe((translated: string) => {
      this.title = translated;
    });

    this.translate.get('PRIMARYCAREVISIT.DESCRIPTION').subscribe((translated: string) => {
      this.description = translated;
    });

    this.translate.get('SHOW_MORE').subscribe((translated: string) => {
      this.showMoreText = translated;
    }); 

  }

  showMeMore() {
    const isMobileLaunch = window.location.href.includes('mobile');
    const isPlus = sessionStorage.getItem("isPlus") != null ? sessionStorage.getItem("isPlus") === 'true'  : null;
    const eptID = sessionStorage.getItem("eptID") ?? "";
    
    if (eptID == null || eptID.length === 0) {
      this.showMeMoreUnAuth(isMobileLaunch);
    }
    else {
      this.showMeMoreAuth(isPlus);
    }
  }

  showMeMoreUnAuth(isMobileLaunch: boolean) {
    var deepLink = isMobileLaunch ? environment.mobile_open_scheduling_deep_link_base_url : environment.web_open_scheduling_deep_link_base_url;
    var platform = isMobileLaunch ? 'mobile-plus' : 'web';

    deepLink += "?specialtyId=17,117,125" +"&selRfvId=" + environment.office_visit_prc_id; 
    deepLink += "&linksource=PLUAPCV";
    
    console.log("Show me more clicked (pcp)");
    console.log(deepLink);

    this.monitoringService.logEvent('ShowMore/NoAuth', { feature: 'get-care-now', subfeature: 'PCP', platform: platform }); // log as web event

    window.location.href = deepLink;
  }

  showMeMoreAuth(isPlus: boolean | null) {
    var showMeMoreSpecialtyId = this.primaryCareProviderOptions.length > 0 ? this.primaryCareProviderOptions[0].showMeMoreSpecialtyId : ''; 
    
    var deepLink = '';
    if (this.isPlus == null) {
      deepLink = environment.web_scheduling_deep_link_base_url; // For web users, use the web deep link

      this.monitoringService.logEvent('ShowMore', { feature: 'get-care-now', subfeature: 'PCP', platform: 'web' }); // log as web event
    }
    else {
      deepLink = this.isPlus 
        ? environment.mobile_scheduling_deep_link_base_url // For Plus users, use the Mobile deep link
        : environment.epic_scheduling_deep_link_base_url; //  For non-Plus users, use the epic deep link

      var mobilePlatform = this.isPlus ? 'mobile-plus' : 'mobile-standard';
      this.monitoringService.logEvent('ShowMore', { feature: 'get-care-now', subfeature: 'PCP', platform: mobilePlatform }); // log as mobile or web event
    }
    
    deepLink += `?workflow=newprovider&selRfvId=${environment.office_visit_prc_id}&specialtyId=${showMeMoreSpecialtyId}`; 
    deepLink += "&linksource=AUTHPCPSCHED";

    console.log("Show me more clicked (pcp)");
    console.log(deepLink);

    window.location.href = deepLink;
  }
}